import script from "./PtoConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./PtoConfig.vue?vue&type=script&setup=true&lang=ts"

import "./PtoConfig.vue?vue&type=style&index=0&id=84386a86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84386a86"]])

export default __exports__